import { isGlassesBundleOrderLineItem, isNonPrescriptionBundleOrderLineItem, isContactLensesOrderLineItem, isSolutionOrderLineItem, isContactLensesBundleOrderLineItem } from "../../../../../utils/Orders/mappers/view/utils/order-line-item-product-type-guards.js";
import { toContactLensesBundleOrderLineItem } from "./contact-lenses-bundle-line-item.js";
import { toContactLensesOrderLineItem } from "./contact-lenses-line-item.js";
import { toGlassesBundleOrderLineItem, toGlassesBundleNonPrescriptionOrderLineItem } from "./glasses-bundle-line-item.js";
import { toRegularOrderLineItem } from "./regular-line-item.js";
import { toSolutionOrderLineItem } from "./solution-line-item.js";
const toOrderLineItem = (intl, options = {}, lineItem) => {
  if (isGlassesBundleOrderLineItem(lineItem)) {
    return toGlassesBundleOrderLineItem(lineItem, intl, options);
  }
  if (isNonPrescriptionBundleOrderLineItem(lineItem)) {
    return toGlassesBundleNonPrescriptionOrderLineItem(lineItem, intl, options);
  }
  if (isContactLensesOrderLineItem(lineItem)) {
    return toContactLensesOrderLineItem(lineItem, intl, options);
  }
  if (isSolutionOrderLineItem(lineItem)) {
    return toSolutionOrderLineItem(lineItem, intl, options);
  }
  if (isContactLensesBundleOrderLineItem(lineItem)) {
    return toContactLensesBundleOrderLineItem(lineItem, intl, options);
  }
  return toRegularOrderLineItem(lineItem, intl, options);
};
export {
  toOrderLineItem
};
//# sourceMappingURL=order-line-item.js.map
